/**
 * Created by user on 2018/2/7/007.
 */

import { globalJsdom } from './lib/global';
export = globalJsdom;
